import { render } from "./transition-height.vue?vue&type=template&id=a1a0fe38"
import script from "./transition-height.vue?vue&type=script&lang=js"
export * from "./transition-height.vue?vue&type=script&lang=js"

import "./transition-height.vue?vue&type=style&index=0&id=a1a0fe38&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__